export default {
    checkSpecialCharacter,
    checkEmojisCharacter,
    checkSpecialCharacterForFoldername,
    checkSpecialCharacterForFoldername_special_structure,
    checkSpecialCharacter_AspectKey
  };
  
  function checkSpecialCharacter() {
    let resultString = ""
    return resultString
  }

  function checkEmojisCharacter() {
    
    return /\p{Emoji}/u;
  }

  function checkSpecialCharacterForFoldername() {
    // const emojiRegex = /^[a-z-A-Z_ก-๙0-9()@#$!+^&=\s]*$/
    const SpecialCharacterRegex = /^((?![<>:*?\\|/"']).)*$/s
    return SpecialCharacterRegex;
  }

  function checkSpecialCharacterForFoldername_special_structure() {
    // const emojiRegex = /^[a-z-A-Z_ก-๙0-9()@#$!+^&=\s]*$/
    const SpecialCharacterRegex = /^((?![<>:*?\\|"']).)*$/s
    return SpecialCharacterRegex;
  }

  function checkSpecialCharacter_AspectKey() {
    // const emojiRegex = /^[a-z-A-Z_ก-๙0-9()@#$!+^&=\s]*$/
    const SpecialCharacterRegex = /^((?![<>:*%.?\\|/"']).)*$/s
    return SpecialCharacterRegex;
  }